import { render, staticRenderFns } from "./folyo.vue?vue&type=template&id=014730b2"
import script from "./folyo.vue?vue&type=script&lang=js"
export * from "./folyo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports